<!-- ═══════════════════════════════════════════════════════
     SPOTLIGHT LAYOUT
     One large tile on the left, sidebar strip on the right
     ════════════════════════════════════════════════════════ -->
@if (isSpotlight()) {
  <div class="hx-video-grid__spotlight-main">
    @if (spotlightParticipant(); as p) {
      <hx-video-tile
        class="hx-video-grid__spotlight-tile"
        [participantName]="p.name"
        [participantInitials]="p.initials ?? ''"
        [avatarSrc]="p.avatarSrc ?? null"
        [isMuted]="p.isMuted ?? false"
        [isVideoOff]="p.isVideoOff ?? false"
        [isSpeaking]="p.isSpeaking ?? false"
        [isPinned]="isPinned(p)"
        [isConnectionPoor]="(p.connectionQuality ?? 4) < 2"
        [videoElement]="p.videoElement ?? null"
        size="full"
        aspectRatio="16/9"
        (tileClick)="pinParticipant.emit(p)" />
    }
  </div>

  @if (sidebarParticipants().length > 0) {
    <div class="hx-video-grid__sidebar" role="list" aria-label="Other participants">
      @for (p of sidebarParticipants(); track p.id) {
        <hx-video-tile
          class="hx-video-grid__sidebar-tile"
          role="listitem"
          [participantName]="p.name"
          [participantInitials]="p.initials ?? ''"
          [avatarSrc]="p.avatarSrc ?? null"
          [isMuted]="p.isMuted ?? false"
          [isVideoOff]="p.isVideoOff ?? false"
          [isSpeaking]="p.isSpeaking ?? false"
          [isPinned]="isPinned(p)"
          [isConnectionPoor]="(p.connectionQuality ?? 4) < 2"
          [videoElement]="p.videoElement ?? null"
          size="full"
          aspectRatio="16/9"
          (tileClick)="pinParticipant.emit(p)" />
      }
    </div>
  }
}

<!-- ═══════════════════════════════════════════════════════
     GALLERY LAYOUT (auto-tier based on count)
     ════════════════════════════════════════════════════════ -->
@if (!isSpotlight()) {
  <div class="hx-video-grid__gallery" role="list" aria-label="Call participants">
    @for (p of galleryParticipants(); track p.id) {
      <hx-video-tile
        class="hx-video-grid__gallery-tile"
        role="listitem"
        [participantName]="p.name"
        [participantInitials]="p.initials ?? ''"
        [avatarSrc]="p.avatarSrc ?? null"
        [isMuted]="p.isMuted ?? false"
        [isVideoOff]="p.isVideoOff ?? false"
        [isSpeaking]="p.isSpeaking ?? false"
        [isPinned]="isPinned(p)"
        [isConnectionPoor]="(p.connectionQuality ?? 4) < 2"
        [videoElement]="p.videoElement ?? null"
        size="full"
        aspectRatio="16/9"
        (tileClick)="pinParticipant.emit(p)" />
    }

    <!-- Overflow chip – shown as the last "tile" when count > maxVisible -->
    @if (overflowCount() > 0) {
      <button
        hxButton
        startItem="cc-people"
        variant="ghost"
        context="neutral"
        class="hx-video-grid__overflow-chip"
        type="button"
        [attr.aria-label]="overflowCount() + ' more participants'"
        (click)="showMoreClicked.emit()">
        <span>+{{ overflowCount() }} more</span>
      </button>
    }
  </div>
}

<!-- ═══════════════════════════════════════════════════════
     SELF-VIEW PIP (local participant, corner overlay)
     ════════════════════════════════════════════════════════ -->
@if (showSelfView() && localParticipant(); as local) {
  <div class="hx-video-grid__self-view" aria-label="Your video">
    <hx-video-tile
      [participantName]="local.name"
      [participantInitials]="local.initials ?? ''"
      [avatarSrc]="local.avatarSrc ?? null"
      [isMuted]="local.isMuted ?? false"
      [isVideoOff]="local.isVideoOff ?? false"
      [isSpeaking]="false"
      [isLocal]="true"
      [videoElement]="local.videoElement ?? null"
      size="full"
      aspectRatio="16/9" />
  </div>
}
